import {
  Investment,
  useInvestmentPerformance,
  useTradingGainForInvestment,
} from "@bn/api/apiv1";

interface Params {
  investmentId: number;
  investment?: Investment;
}

/**
 * Figures shown under the investment chart. The app has no global currency
 * switch, so everything is read in the investment's own currency.
 */
export const useInvestmentPerformanceOverview = ({
  investmentId,
  investment,
}: Params) => {
  const realizedGainsQuery = useTradingGainForInvestment(
    { id: investmentId },
    { enabled: investmentId !== undefined }
  );
  const investmentPerformanceQuery = useInvestmentPerformance(
    { id: investmentId },
    { enabled: investmentId !== undefined }
  );

  const netGain = realizedGainsQuery.data?.accumulatedGain?.netGain ?? 0;
  const returnOnInvestment = investment?.returnOnInvestment ?? 0;
  const returnOnInvestmentInPercent =
    investment?.returnOnInvestmentInPercent ?? 0;
  const performance =
    investmentPerformanceQuery.data?.inInvestmentCurrency?.twrorWithDividends ??
    0;

  const gainAndLoss = netGain + returnOnInvestment;

  return {
    netGain,
    returnOnInvestment,
    returnOnInvestmentInPercent,
    performance,
    gainAndLoss,
  };
};
